module.exports = __webpack_public_path__ + "img/Philippines.50bc03a6.png";